import React from 'react';

import { StyledIndicatorComp, StyledImageBoxComp } from './subcomponents';

import { IGetTitleColor } from '../types';
import { Colors } from '../../types';

import { StyledIconBox } from './styles';
import { Image } from '../../Image';

interface GetImage {
    icon?: string;
    image?: string;
    checkbox?: boolean;
    short?: boolean;
    borderWidth?: number;
    isBadgeRightCorner?: boolean;
    isLeft?: boolean;
}

export const getImage = ({ icon, image, checkbox, short, borderWidth, isBadgeRightCorner, isLeft }: GetImage) => {
    if (checkbox) {
        return <StyledIndicatorComp left={isLeft} />;
    }

    if (image && !isBadgeRightCorner) {
        return <StyledImageBoxComp borderWidth={borderWidth} left={isLeft} image={image} />;
    }

    if (icon) {
        return (
            <StyledIconBox left={isLeft} short={short}>
                <Image src={icon} alt="ic" />
            </StyledIconBox>
        );
    }

    return null;
};

export const getTitleColor = ({ indicated, checked }: IGetTitleColor) => {
    return checked && !indicated ? 'on-primary' : 'text-main';
};

export const getSubtitleColor = ({ indicated, checked }: IGetTitleColor) => {
    return checked && !indicated ? 'on-primary' : 'text-secondary';
};

export const getBadgeColor = ({ indicated, checked, badgeColor }: IGetTitleColor & { badgeColor?: Colors }) => {
    return checked && !indicated ? 'primary-default' : badgeColor || 'decorative-c';
};

export const getBadgeBackgroundColor = ({
    indicated,
    checked,
    badgeBackground,
}: IGetTitleColor & { badgeBackground?: Colors }) => {
    return checked && !indicated ? 'on-primary' : badgeBackground || 'decorative-b';
};
